var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"word-wrap":"break-word"},domProps:{"innerHTML":_vm._s(_vm.data.questionFreeText)},on:{"copy":function($event){return _vm.copyText()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }